/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  toStoredData.ts
 */

import { ExpirableLRUOptions } from '../types/ExpirableLRUOptions'
import { StoredData } from '../types/StoredData'

export const toStoredData = <TValue = any>(
  value: TValue,
  options: ExpirableLRUOptions<any, TValue>
): StoredData<TValue> => [value, options.version, options.ttl, Date.now()]
